export default {"src":"/_next/static/media/recycle-bin.23081fb4.svg","height":24,"width":22,"blurWidth":0,"blurHeight":0};